module.exports = __webpack_public_path__ + "img/s2.4b08ce63.svg";